import React, { useState, useEffect } from "react";
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function DashboardTab({ user, users, leaves, onAddUser }) {
  const [stats, setstats] = useState({
    earnedLeaves: 0,
    sickLeavesTaken: 0,
    casualLeavesTaken: 0,
    totalLeavesTaken:0,
  });

  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  useEffect(() => {
     const calculateStats = async () => {
       if (user.role === "employee") {
         const usersResponse = await axios.get(
           `${API}/users/details`,
           axiosConfig
         );
         const user_details = usersResponse.data.data.user;


         setstats({
           earnedLeaves: user_details.earned_leaves,
           sickLeavesTaken: user_details.sick_leaves_taken,
           casualLeavesTaken: user_details.casual_leaves_taken,
           totalLeavesTaken:
             user_details.sick_leaves_taken + user_details.casual_leaves_taken,
         });
       }
       return null;
     };
    calculateStats();
  }, []);
 

  const getUserName = (userId) => {
    const foundUser = users.find(u => u.id === userId);
    return foundUser ? foundUser.name : 'Unknown';
  };


  return (
    <div data-testid="dashboard-tab">
      {user.role === "employee" && stats && (
        <div className="stats-grid">
          <div className="stat-card" data-testid="earned-leaves-card">
            <div className="stat-label">Earned Leaves</div>
            <div className="stat-value">{stats.earnedLeaves.toFixed(1)}</div>
          </div>
          <div className="stat-card" data-testid="sick-leaves-card">
            <div className="stat-label">Sick Leaves Taken</div>
            <div className="stat-value">{stats.sickLeavesTaken.toFixed(1)}</div>
          </div>
          <div className="stat-card" data-testid="casual-leaves-card">
            <div className="stat-label">Casual Leaves Taken</div>
            <div className="stat-value">
              {stats.casualLeavesTaken.toFixed(1)}
            </div>
          </div>
          <div className="stat-card" data-testid="total-leaves-card">
            <div className="stat-label">Total Leaves Taken</div>
            <div className="stat-value">
              {stats.totalLeavesTaken.toFixed(1)}
            </div>
          </div>
        </div>
      )}

      {(user.role === "admin" || user.role === "manager") && (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <h2 style={{ fontSize: "1.5rem", fontWeight: "700" }}>
              Team Members
            </h2>
            <button
              className="add-btn"
              onClick={onAddUser}
              data-testid="add-employee-btn"
            >
              + Add {user.role === "manager" ? "Employee" : "User"}
            </button>
          </div>

          {users.length > 0 ? (
            <div style={{ overflowX: "auto" }}>
              <table className="data-table" data-testid="users-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Earned Leaves</th>
                    <th>Sick Leaves</th>
                    <th>Casual Leaves</th>
                    <th>Total Taken</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((u) => (
                    <tr key={u.id} data-testid={`user-row-${u.id}`}>
                      <td data-testid={`user-name-${u.id}`}>{u.name}</td>
                      <td data-testid={`user-email-${u.id}`}>{u.email}</td>
                      <td>
                        <span
                          className="status-badge"
                          style={{ background: "#e6f2ff", color: "#0066cc" }}
                        >
                          {u.role}
                        </span>
                      </td>
                      <td data-testid={`user-earned-${u.id}`}>
                        {u.earned_leaves.toFixed(1)}
                      </td>
                      <td data-testid={`user-sick-${u.id}`}>
                        {u.sick_leaves_taken.toFixed(1)}
                      </td>
                      <td data-testid={`user-casual-${u.id}`}>
                        {u.casual_leaves_taken.toFixed(1)}
                      </td>
                      <td data-testid={`user-total-${u.id}`}>
                        {(u.sick_leaves_taken + u.casual_leaves_taken).toFixed(
                          1,
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-state" data-testid="no-users-message">
              <p>No team members found</p>
            </div>
          )}
        </div>
      )}

      {user.role === "employee" && (
        <div style={{ marginTop: "2rem" }}>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "700",
              marginBottom: "1rem",
            }}
          >
            My Leave History
          </h2>
          {leaves.length > 0 ? (
            <div style={{ overflowX: "auto" }}>
              <table className="data-table" data-testid="leaves-table">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Duration</th>
                    <th>Status</th>
                    <th>Reason</th>
                    <th>Unpaid Duration</th>
                  </tr>
                </thead>
                <tbody>
                  {leaves.map((leave) => (
                    <tr key={leave.id} data-testid={`leave-row-${leave.id}`}>
                      <td style={{ textTransform: "capitalize" }}>
                        {leave.leave_type}
                      </td>
                      <td>
                        {new Date(leave.start_date).toLocaleDateString("en-IN")}
                      </td>
                      <td>
                        {new Date(leave.end_date).toLocaleDateString("en-IN")}
                      </td>
                      <td>
                        {leave.duration} {leave.duration === 1 ? "day" : "days"}
                      </td>
                      <td>
                        <span className={`status-badge status-${leave.status}`}>
                          {leave.status}
                        </span>
                      </td>
                      <td>{leave.reason}</td>
                      <td>{leave.unpaid_leaves}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-state" data-testid="no-leaves-message">
              <p>No leave applications yet</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default DashboardTab;